export enum ResourceServiceType {
  SET_VIEW = 'SET_VIEW',
  FETCH_RESOURCES = 'FETCH_RESOURCES',
  FETCH_RESOURCES_SUCCESS = 'FETCH_RESOURCES_SUCCESS',
  FETCH_RESOURCES_FAILED = 'FETCH_RESOURCES_FAILED',
  SUBMITING_ATTACHMENT = 'SUBMITING_ATTACHMENT',
  SUBMIT_ATTACHMENT_SUCCESS = 'SUBMIT_ATTACHMENT_SUCCESS',
  SUBMIT_ATTACHMENT_ERROR = 'SUBMIT_ATTACHMENT_ERROR',
  SELECT_ATTACHMENT_UPLOAD = 'SELECT_ATTACHMENT_UPLOAD',
  ATTACHMENT_UPLOADING_STATE = 'ATTACHMENT_UPLOADING_STATE',
  ATTACHMENT_UPLOAD_SUCCESS = 'ATTACHMENT_UPLOAD_SUCCESS',
  ATTACHMENT_PROCESS_SUCCESS = 'ATTACHMENT_PROCESS_SUCCESS',
  ATTACHMENT_PROCESSING_STATE = 'ATTACHMENT_PROCESSING_STATE',
  ATTACHMENT_UPLOAD_FAILED = 'ATTACHMENT_UPLOAD_FAILED',
  SELECT_ATTACHMENT = 'SELECT_ATTACHMENT',
  DELETE_RESOURCE = 'DELETE_RESOURCE',
  DELETE_RESOURCE_SUCCESS = 'DELETE_RESOURCE_SUCCESS',
  DELETE_RESOURCE_FAILED = 'DELETE_RESOURCE_FAILED',
  REARRANGE_RESOURCE = 'REARRANGE_RESOURCE',
  REARRANGE_RESOURCE_SUCCESS = 'REARRANGE_RESOURCE_SUCCESS',
  REARRANGE_RESOURCE_FAILED = 'REARRANGE_RESOURCE_FAILED',
  FETCH_RESOURCE_SETTING = 'FETCH_RESOURCE_SETTING',
  FETCH_RESOURCE_SETTING_SUCCESS = 'FETCH_RESOURCE_SETTING_SUCCESS',
  FETCH_RESOURCE_SETTING_FAILED = 'FETCH_RESOURCE_SETTING_FAILED',
  CANCEL_ATTACHMENT_UPLOAD = 'CANCEL_ATTACHMENT_UPLOAD',
  ATTACHMENT_NOT_FOUND = 'ATTACHMENT_NOT_FOUND',
  GOTO_LISTING_PAGE = 'GOTO_LISTING_PAGE',
  ADD_UPLOADER = 'ADD_UPLOADER',
  REMOVE_FILE_PROCESSING = 'REMOVE_FILE_PROCESSING',
  SAVE_STATUS_INTERVAL = 'SAVE_STATUS_INTERVAL',
  SET_VIEW_ONLY = 'SET_VIEW_ONLY',
  UPDATE_CANCELLED_STATE = 'UPDATE_CANCELLED_STATE',
  ATTACHMENT_PROCESSING_FAILED = 'ATTACHMENT_PROCESSING_FAILED',
  FETCH_VIDEO_SETTINGS = 'FETCH_VIDEO_SETTINGS',
  FETCH_VIDEO_SETTINGS_SUCCESS = 'FETCH_VIDEO_SETTINGS_SUCCESS',
  FETCH_VIDEO_SETTINGS_FAILED = 'FETCH_VIDEO_SETTINGS_FAILED'
}

export interface ResourceServiceResponseInterface {
  id: string
  externalId: string
  externalIdV2: string
  realm: {
    id: number
  }
  firstName: string
  email: string
  lastName: string
  timeZone: string
  realmUserId: string
  jobTitle: string
  level: string
  companyName: string
  companySize: string
  telephone: string
  industry: string
  country: string
  stateRegion: string
  roles: string[]
}
